import { Component } from '@angular/core';
import { OpenerSchemeRewardRule } from 'src/app/api/api-campaigns.service.generated';
import { OpenerSchemeRuleEditComponent, SavedRule } from '../opener-scheme-rule-edit/opener-scheme-rule-edit.component';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from "wecheer-common";

@Component({
  selector: 'app-opener-scheme-rules',
  templateUrl: './opener-scheme-rules.component.html',
  styleUrls: ['./opener-scheme-rules.component.scss'],
  imports: [
    OpenerSchemeRuleEditComponent,
    MatIconModule,
    ButtonComponent
]
})
export class OpenerSchemeRulesComponent {

  openerSchemeRewardRules: OpenerSchemeRewardRule[] = [];
  public savedRules: OpenerSchemeRewardRule[] = [];

  constructor() {
  }

  public setFormValue(rules: OpenerSchemeRewardRule[]) {
    // add empty item if none
    if (!rules || rules.length === 0) {
      rules = [new OpenerSchemeRewardRule({ bottleProducts: [], pointsPerBottle: 0 })];
    }
    this.openerSchemeRewardRules.push(...rules);
  }

  addRule() {
    this.openerSchemeRewardRules.push(new OpenerSchemeRewardRule({ bottleProducts: [], pointsPerBottle: 0 }));
  }

  onRemoveRule(index: number) {
    this.savedRules.splice(index, 1);
    this.openerSchemeRewardRules.splice(index, 1);
  }

  onSaveRule(savedRule: SavedRule) {
    this.savedRules[savedRule.index] = savedRule.rule;
  }
}
